module.exports = __webpack_public_path__ + "img/Kodefast.9f0eb38c.svg";